import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback } from 'react';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../../../../controllers/view-configuration';
export var useRegisterFields = function useRegisterFields(_ref) {
  var appId = _ref.appId;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    setError = _useIssueAdjustmentsA.setError,
    registerFields = _useIssueAdjustmentsA.registerFields;
  var viewType = useViewType();
  return useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var fields, changeId, validFieldIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fields = _ref2.fields, changeId = _ref2.changeId;
            _context.prev = 1;
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validFieldIds = fields.filter(function (fieldId) {
              return typeof fieldId === 'string';
            }); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') {
              registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
              });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            _context.next = 10;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            setError({
              errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw _context.t0;
          case 10:
            _context.prev = 10;
            getAnalytics(viewType).markFieldsRegistered();
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6, 10, 13]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [appId, registerFields, setError, viewType]);
};